import Insight from "../insightClass";
import React from "react";
import { insight28Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight054 = new Insight(
  "11 July 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight28Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-07-11)",
  "",
  `UK government reportedly plans to scrap zonal pricing, which would have differentiated wholesale rates by region, amid opposition. The reform faced concerns over affordability and complexity, and may be abandoned in favour of a more unified market design.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-07-11)</h1>
    <h2></h2>
    <p className="article-date">11 July 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>
      1. UK: Ministers expected to drop ‘zonal pricing’ electricity market
      reform
    </h3>
    <p>
      UK government reportedly plans to scrap zonal pricing, which would have
      differentiated wholesale rates by region, amid opposition. The reform
      faced concerns over affordability and complexity, and may be abandoned in
      favour of a more unified market design. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Energy market reform affects revenue certainty for offshore generators.
      The decision signals need to stabilize regulatory frameworks for investor
      confidence. A uniform price model limits regional distortion but may
      reduce locational signals necessary for grid planning and network
      investments.
    </p>
    <h3>
      2. Fugro and TGS conduct detailed surveys for Norway’s first commercial
      offshore wind farm
    </h3>
    <p>
      Fugro and TGS have commenced deep cone penetration and borehole surveys at
      planned turbine sites and converter station locations—part of pre
      construction groundwork for Norway’s first commercial offshore wind farm. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Early-stage geotechnical work is vital for foundation design and grid
      interconnection planning. Knowing seabed conditions upfront enables
      optimized monopile or jacket solution selection and reduces cost overruns.
      Encouraged approach for emerging markets with complex geology.
    </p>
    <h3>
      3. Europe: First turbine installed at 1.2 GW Baltic Power offshore wind
      farm in Poland
    </h3>
    <p>
      The first Vestas V236 15 MW turbine has been successfully installed at
      Baltic Power’s 1.2 GW offshore wind site—the first in Poland. With 76
      turbines planned, the project will power over 1.5 million households
      (≈ 3 % of national demand). Full commissioning is expected in 2026. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This milestone marks Poland’s emergence in offshore wind
      industrialisation. Deploying 15 MW turbines demonstrates ambition and
      execution maturity. Logistics via Wind Osprey vessel show strong marine
      coordination. Future stages should focus on supply chain localisation and
      decreasing installation risk through repeatability.
    </p>
    <h3>4. Ports of Augusta and Taranto designated as offshore wind hubs</h3>
    <p>
      Italy has approved a decree establishing Augusta and Taranto as
      manufacturing and assembly hubs for offshore wind. These ports will anchor
      domestic component fabrication, vessel staging, and logistical
      coordination, supporting Mediterranean deployment and fostering local
      industrialisation. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Strategic port infrastructure investment catalyses industrial clustering.
      Anchor hubs in Italy may reduce reliance on Northern European yards and
      lower transport lead times. Developers and OEMs should explore co
      investment opportunities to leverage local manufacturing and port staging
      capabilities.
    </p>
    <h3>
      5. Europe North America (Canada): Oceanic Wind Energy and CTE receive
      permit for offshore wind project study in Canada
    </h3>
    <p>
      Oceanic Wind Energy and Canadian Transmission Exploration (CTE) have been
      granted a federal permit to conduct pre development offshore wind site
      studies in Canadian waters, including environmental and resource
      assessments. This marks early but critical progress toward establishing
      Canada’s fledgling offshore wind sector.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Securing federal permitting for early phase surveying is vital to unlock
      latent market potential in Canada. These studies will define seabed,
      vessel access, and environmental risk parameters—essential foundation for
      attracting investment and enabling future leasing auctions. Focus should
      now turn to stakeholder engagement and grid planning.
    </p>
    <h3>
      6. Asia Pacific: Grid interconnection deal sealed for 1 GW South Korean
      offshore wind projects
    </h3>
    <p>
      South Korea’s KEPCO has inked a grid interconnection agreement enabling
      export of 1 GW from Haesong Offshore Wind 1 and 3 projects. This
      transmission deal clears a key hurdle ahead of construction. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Securing grid access is often the gating factor for project development.
      This deal unlocks Haesong’s commercial viability and enables investor
      confidence. Lessons extend to floating wind clusters. Early coordination
      between developers and grid operator proves invaluable for timeline de
      risking.
    </p>
    <h3>7. Asia Pacific: New turbine installation vessel launched in China</h3>
    <p>
      The DEME built vessel “Norse Energi” was floated out in Yantai ahead of
      final outfitting. Designed for wind turbine installation, the vessel
      enhances Chinese offshore construction capacity for large-scale APAC
      projects. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Expanding vessel fleet improves regional logistics capability. Local lift
      and installation assets reduce dependency on Western vessels and
      accelerate project timelines. For international developers, this signals
      more competitive crew and marine infrastructure in Chinese shipyards.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
